import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";


import "../../App.css";
import { MaterialSymbolsMenu } from "../visual/icons";
import { isImpersonating, restoreImpersonatedSession } from "../../utils/impersonation";



function Headerappprivate(props) {
    const navigate = useNavigate();
    const [role, setRole] = useState([]);
    const [fullname, setFullName] = useState();
    const [casino, setCasino] = useState();
    const [impersonating, setImpersonating] = useState(false);

    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const normalizeStorageValue = (key) => {
        const rawValue = window.localStorage.getItem(key);
        return rawValue == null ? "" : rawValue.replace(/"/g, "");
    };

    const volverASuperadmin = () => {
        const returnPath = restoreImpersonatedSession();
        const restoredAuthCode = normalizeStorageValue("MY_APP_STATE_AUTHCODE");
        setImpersonating(false);
        navigate(returnPath || `/AdminUsers/${restoredAuthCode}`);
    };

    const roleList = role.map((item, i) => (
        <li key={i} className="w-fit">
            {console.log(item)}
            <Link
                className="text-white no-underline hover:opacity-80"
                to={`${item.path}/${normalizeStorageValue("MY_APP_STATE_AUTHCODE")}`}
            >
            <button 
                className={`w-full px-4 py-2 min-h-[4.5rem] rounded ${['Carga Billetera', 'Movimientos Billetera', 'Compra Cafeteria', 'Ordenes Cafeteria'].includes(item.nombre) ? 'bg-yellow-400 text-black hover:bg-yellow-500' : 'bg-red-600 text-white hover:bg-red-700' }`}
            >
                {item.nombre}
            </button>
            </Link>
        </li>
    ));

    

    useEffect(() => {
        const rawRole = window.localStorage.getItem("MY_APP_STATE_ROLE");
        setRole(rawRole ? JSON.parse(rawRole) : []);
        setFullName(normalizeStorageValue("MY_APP_STATE_PROF_NAME") || "Usuario");
        setCasino(normalizeStorageValue("MY_APP_STATE_PROF_CASINO") || "");
        setImpersonating(isImpersonating());
    }, []);

    return (
        <>
            {/* Navbar */}
            <nav className="bg-black py-3 px-4">
                <div className="flex gap-8 lg:justify-start text-white justify-between">
                    <div className="text-white text-center sm:text-start">
                        <h5 className="text-base sm:text-lg">Casino {casino}</h5>
                    </div>
                    {impersonating && (
                        <button
                            onClick={volverASuperadmin}
                            className="hidden lg:inline-flex items-center rounded bg-amber-400 px-4 py-2 text-sm font-semibold text-black hover:bg-amber-300"
                        >
                            Volver a Superadmin
                        </button>
                    )}
                    {/* Role List for larger screens */}
                    <div className="hidden lg:flex text-white text-center gap-4 text-lg">
                        {roleList}
                    </div>
                    {/* Hamburger Menu for smaller screens */}
                    <div className="lg:hidden object-end">
                        <MaterialSymbolsMenu onClick={toggleMenu} />
                    </div>
                </div>
            </nav>

            {/* Dropdown Menu */}
            {isOpen && (
                <div className="absolute w-full bg-[#5e2b41] bg-opacity-90 backdrop-blur text-white shadow-md z-40">
                    <div className="py-2 space-y-4 px-4 ">
                        {impersonating && (
                            <button
                                onClick={volverASuperadmin}
                                className="inline-flex items-center rounded bg-amber-400 px-4 py-2 text-sm font-semibold text-black hover:bg-amber-300"
                            >
                                Volver a Superadmin
                            </button>
                        )}
                        <ul className="space-y-4">{roleList}</ul>
                    </div>
                </div>
            )}

            {impersonating && (
                <div className="bg-amber-100 px-4 py-2 text-center text-sm font-medium text-amber-900">
                    Modo impersonación activo.
                </div>
            )}

            <header className="text-center bg-[#f1f1f1] py-3">
                <h3>Bienvenido/a {fullname}</h3>
            </header>
        </>
    );
}

export default Headerappprivate;
